<template>
  <div class="flexbox vertical">
    <header class="page-header">
      <van-icon name="arrow-left" @click="$router.go(-1)" />
      <span>{{ $t('中国仓库收货地址') }}</span>
      <span></span>
    </header>
    <main class="flex-fill page-body">
      <div class="address round">
        <div class="theme-color indent">
          {{ $t('EnterPackage.kqs54j') }}
        </div>
        <!-- 使用 van-collapse 显示仓库信息 -->
        <van-collapse v-model="activeName" accordion @change="onCollapseChange">
          <van-collapse-item
            v-for="warehouse in warehouseList"
            :key="warehouse.PK_ID"
            :title="warehouse.sName"
            :name="warehouse.PK_ID"
          >
            <div>
              {{ $t('EnterPackage.5jllo7') }}
              {{ warehouse.sContactor }}
              #{{ userInfo != null ? userInfo.sCustNo : '' }}
            </div>
            <div>
              {{ $t('EnterPackage.bzs54i') }}{{ warehouse.sContactTel }}
            </div>
            <div>{{ $t('EnterPackage.f4o25k') }}{{ warehouse.sZipCode }}</div>
            <div>
              {{ $t('EnterPackage.uc0c1f') }}
              {{ getAddress(warehouse) }}
              #{{ userInfo != null ? userInfo.sCustNo : '' }}
            </div>
            <div>{{ $t('EnterPackage.8qeqyj') }}{{ warehouse.sDesc }}</div>

            <!-- 添加一键复制按钮 -->
            <!-- <div class="x-center">
              <van-button
                type="info"
                size="small"
                :data-clipboard-text="formatWarehouseInfo(warehouse)"
                @click="copy"
              >
                {{ $t('一键复制') }}
              </van-button>
            </div> -->
          </van-collapse-item>
        </van-collapse>
        <div class="indent">
          <!-- <div>
            <span class="inf">
              {{ $t('EnterPackage.5jllo7') }} {{ stock_rec_name }}
            </span>
            <van-button
              class="mini-button"
              size="mini"
              id="copy"
              :data-clipboard-text="stock_rec_name"
              @click="copy"
              type="info"
              >{{ $t('复制') }}</van-button
            >
          </div>
          <div>
            {{ $t('EnterPackage.bzs54i') }} {{ stock_rec_tel }}
            <van-button
              class="mini-button"
              size="mini"
              id="copy"
              :data-clipboard-text="stock_rec_tel"
              @click="copy"
              type="info"
              >{{ $t('复制') }}</van-button
            >
          </div>
          <div>
            {{ $t('EnterPackage.f4o25k') }} {{ stock_rec_zipcode }}
            <van-button
              class="mini-button"
              size="mini"
              id="copy"
              :data-clipboard-text="stock_rec_zipcode"
              @click="copy"
              type="info"
              >{{ $t('复制') }}</van-button
            >
          </div>
          <div>
            {{ $t('EnterPackage.uc0c1f') }} {{ stock_rec_addr }}
            <van-button
              class="mini-button"
              size="mini"
              id="copy"
              :data-clipboard-text="stock_rec_addr"
              @click="copy"
              type="info"
              >{{ $t('复制') }}</van-button
            >
          </div>
          <div>
            {{ $t('EnterPackage.8qeqyj') }} {{ stock_rec_remark }}
            <van-button
              class="mini-button"
              size="mini"
              id="copy"
              :data-clipboard-text="stock_rec_remark"
              @click="copy"
              type="info"
              >{{ $t('复制') }}</van-button
            >
          </div> -->
          <div>{{ $t('EnterPackage.sb9f6s') }} {{ stock_rec_worktime }}</div>
          <div>{{ $t('EnterPackage.o6hjut') }}</div>
        </div>
        <div class="express-tns">
          <van-button
            style="background-color:#1989fa;"
            type="primary"
            id="copy"
            :data-clipboard-text="stock_rec_totaladdr"
            @click="copy"
            >{{ $t('Home.oir9894') }}</van-button
          >
        </div>
        <div class="tip">
          {{ $t('EnterPackage.fljdjs') }}
          <div class="danger">
            {{ $t('请务必备注您的会员号，否则仓库入库无法确认所属客户') }}
          </div>
        </div>
        <div class="express-tns">
          <van-button
            type="info"
            @click="$router.push({ name: 'EnterPackage' })"
            >{{ $t('包裹预报') }}</van-button
          >
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import { $t } from '@/plugins/i18n';
import { getStockInfo, getStoreList } from '@/api/deliver.js';
import Clipboard from 'clipboard';
import Vue from 'vue';
import { Collapse, CollapseItem } from 'vant';
Vue.use(Collapse);
Vue.use(CollapseItem);

export default {
  data() {
    return {
      orderNo: '',
      name: '',
      note: '',
      declarePrice: 0,
      stock_name: '',
      stock_rec_name: '',
      stock_rec_tel: '',
      stock_rec_zipcode: '',
      stock_rec_addr: '',
      stock_rec_remark: '',
      stock_rec_worktime: '',
      stock_rec_totaladdr: '',
      mes: '地址',
      activeName: null,
      warehouseList: [],
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
  },
  methods: {
    // 新增折叠面板变化处理方法
    onCollapseChange(active) {
      if (active) {
        const activeWarehouse = this.warehouseList.find(
          warehouse => warehouse.PK_ID === active
        );
        if (activeWarehouse) {
          this.stock_rec_totaladdr = this.formatWarehouseInfo(activeWarehouse);
        }
      }
    },
    // 新增格式化仓库信息的方法
    formatWarehouseInfo(warehouse) {
      if (!warehouse) return '';

      const address = this.getAddress(warehouse);
      const userInfoPart = this.userInfo ? `#${this.userInfo.sCustNo}` : '';

      return (
        `${this.$t('EnterPackage.5jllo7')}${warehouse.sContactor}${userInfoPart}\n` +
        `${this.$t('EnterPackage.bzs54i')}${warehouse.sContactTel}\n` +
        `${this.$t('EnterPackage.f4o25k')}${warehouse.sZipCode}\n` +
        `${this.$t('EnterPackage.uc0c1f')}${address}${userInfoPart}\n` +
        `${this.$t('EnterPackage.8qeqyj')}${warehouse.sDesc}`
      );
    },
    getAddress(warehouse) {
      // 拼接地址信息: 国家 省 市 区 详细地址
      const { sCountryName, sProvince, sCity, sArea, sAddr } = warehouse;
      let address = '';

      if (sCountryName) address += sCountryName;
      if (sProvince) address += sProvince;
      if (sCity && sCity !== sProvince) address += sCity;
      if (sArea) address += sArea;
      if (sAddr) address += sAddr;

      return address;
    },

    loadData() {
      getStockInfo().then(res => {
        if (res.Result == true) {
          var stockInfo = res.DataDict['data'];
          this.stock_name = stockInfo.name;
          this.stock_rec_name = stockInfo.recv;
          this.stock_rec_tel = stockInfo.tel;
          this.stock_rec_zipcode = stockInfo.code;
          this.stock_rec_addr = stockInfo.addr;
          this.stock_rec_remark = stockInfo.note;
          this.stock_rec_worktime = stockInfo.worktime;
          // this.stock_rec_totaladdr =
          //   this.stock_rec_name +
          //   ' ' +
          //   this.stock_rec_tel +
          //   ' ' +
          //   '  ' +
          //   this.stock_rec_addr +
          //   ' ' +
          //   this.stock_rec_zipcode;
          // if (res.DataDict['custNo'] != null) {
          //   this.stock_rec_remark += '(' + res.DataDict['custNo'] + ')';
          // }
        }
      });

      // 获取仓库列表
      getStoreList().then(res => {
        if (res.Result == true) {
          this.warehouseList = res.DataDict['list'];

          // 设置默认展开第一个仓库
          if (this.warehouseList.length > 0) {
            this.activeName = this.warehouseList[0].PK_ID;
            this.stock_rec_totaladdr = this.formatWarehouseInfo(this.warehouseList[0]);
          }
        }
      });
    },
    copy() {
      let _this = this;
      let clipborad = new Clipboard('#copy');
      //复制成功
      clipborad.on('success', function() {
        _this.$toast.success($t('复制成功！'));
        clipborad.destory();
      });
      //复制失败
      clipborad.on('error', function() {
        _this.$toast.fail($t('复制失败！'));
        clipborad.destory();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/_var';
.page-body {
  padding: rem(20px);
}
.round {
  border-radius: rem(10px);
}
.note {
  color: #b8b8b8;
  font-size: 12px;
  line-height: 1.5;
  margin: rem(20px) 0;
}
.express-tns {
  margin: 10px;
  text-align: center;
}
.van-button {
  height: rem(80px);
  width: rem(500px);
  background-color: $theme-color;
  border: none;
  border-radius: rem(25px);
}
.x-center {
  margin: rem(40px) 0;
}
.address {
  background: rgba(#9c9bb4, 0.3);
  padding: rem(20px);
  padding-bottom: rem(40px);
}

.indent {
  margin-left: rem(40px);
  line-height: 2;
  .inf {
    line-height: 0.5rem;
  }
}
.tip {
  padding: rem(32px);
  background: #f6f6f6;
  border-radius: rem(10px);
  .danger {
    color: rgb(235, 8, 8);
  }
}
.text-white {
  color: #fff;
}
.mini-button {
  width: 1.8rem;
  height: 0.4rem;
}
</style>
